import { useTranslation } from '../../../../../../translations';
import { getReward } from '../../../../../../utils/helpers';
import classNames from 'classnames';
import { parseButtonFields } from '../../../utils/parseButtonFields';
import { useApplicationCallbacks } from '../../../../../../providers/application-callbacks';

export default function useAdminModalProps() {
  const { t } = useTranslation();
  const callbacks = useApplicationCallbacks();

  return (modals) => {
    const [{ id, title, description, image, link, prize, redirect, ...rest }] = modals;
    const { field } = getReward(prize, t);
    const prizeData = getPrizeData(prize, field, t);
    const buttons = getButtons(rest, redirect, link);
    const onShow = () => callbacks.markDisposableModalAsShown(id);

    return { id, title, description, productsId: id, image, redirect, ...prizeData, buttons, onShow };
  };
}

function getPrizeData(prize, field, t) {
  return (
    {
      promocode() {
        return {
          promocodeData: {
            promocode: prize.promocode,
            description: prize.description,
            rules: { attr: { href: prize.terms_of_use }, text: t('other.termsOfUse') },
          },
        };
      },
    }[field]?.() ?? {}
  );
}

function getButtons(props, redirect, link) {
  const buttonData = parseButtonFields(props);

  return buttonData.map(({ index, text }) => {
    const className = classNames(
      'quiz-winner-modal__button',
      { 0: 'custom-button_green', 1: 'custom-button_gray' }[index],
    );

    const action = {
      0: redirect ? 'redirect' : 'toShop',
      1: 'close',
    }[index];
    const linkValue = { 0: link }[index];

    return { attr: { className, text }, action, link: linkValue };
  });
}
